import React from 'react';
import HeroComponent from '../components/HeroComponent';
import backgroundImage from '../assets/AboutUsBackground.png';
// import { Story } from '../sections/about-us/Story';
import { OurPromise } from '../sections/about-us/OurPromise';
import { ConnectUs } from '../sections/ConnectUs';
import { Service, ServicesSection, GridLayout } from '../sections/ServicesSection';
import { FaRegClock } from 'react-icons/fa6';
import { LuBuilding2 } from 'react-icons/lu';
import { OurExperience } from '../sections/about-us/OurExperience';
import { PiChartLineUp } from 'react-icons/pi';
import { FiUsers } from 'react-icons/fi';
import { contactInfo } from '../config/navigation';

const services: Service[] = [
  {
    icon: LuBuilding2,
    title: 'Quality First',
    description: 'We believe in investing in good businesses via mutual funds, managed by great managements.',
  },
  {
    icon: PiChartLineUp,
    title: 'Business Growth',
    description: 'Core Belief: Businesses create wealth, not stocks, not funds.',
  },
  {
    icon: FiUsers,
    title: 'Think Different',
    description: 'We are happy to be contrarian when risk reward is compelling: mimicking herd = regression to mean.',
  },
  {
    icon: FaRegClock,
    title: 'Time in Market',
    description: 'There is no alternative to long term investing.',
  },
];

export const AboutUs: React.FC = () => (
  <>
    <HeroComponent
      backgroundImage={backgroundImage}
      title="MoneyQube"
      subtitle="Navigating Your Financial Journey"
      secondaryButton={{ link: `https://wa.me/${contactInfo.phoneNumber}`, text: 'Contact US' }}
    />
    {/* <Story /> */}
    <OurPromise />
    <ServicesSection
      heading="Building Wealth Through Strategic Investment"
      subHeading="Our BELIEF"
      services={services}
      layout={GridLayout.TwoByTwo}
    />
    <OurExperience />
    <ConnectUs />
  </>
);
